import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/imageUtils";

const Footer = ({ lang }) => {
    const getText = (en, ar) => (lang === "en" ? en : ar);
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-custom bg-card">
            <div className="container">
                <div className="row gy-5">
                    <div className="col-lg-4">
                        <Link className="navbar-brand fw-bold text-primary fs-4 mb-3 d-block" to="/">
                            <i className="ri-building-2-line me-2"></i>InnoBridge
                        </Link>
                        <p>
                            {getText(
                                "Empowering businesses with strategic insights and digital solutions.",
                                "تمكين الشركات برؤى استراتيجية وحلول رقمية."
                            )}
                        </p>
                        <div className="d-flex gap-3 mt-4">
                            <a href="#" className="btn btn-sm btn-outline-custom rounded-circle p-2">
                                <i className="ri-linkedin-fill"></i>
                            </a>
                            <a href="#" className="btn btn-sm btn-outline-custom rounded-circle p-2">
                                <i className="ri-instagram-line"></i>
                            </a>
                            <a href="#" className="btn btn-sm btn-outline-custom rounded-circle p-2">
                                <i className="ri-facebook-fill"></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-6">
                        <h5 className="fw-bold mb-3">{getText("Company", "الشركة")}</h5>
                        <ul className="list-unstyled d-flex flex-column gap-2">
                            <li>
                                <Link to="/about" className="text-muted">
                                    {getText("About Us", "من نحن")}
                                </Link>
                            </li>
                            <li>
                                <Link to="/careers" className="text-muted">
                                    {getText("Careers", "الوظائف")}
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="text-muted">
                                    {getText("Blog", "المدونة")}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-2 col-6">
                        <h5 className="fw-bold mb-3">{getText("Support", "الدعم")}</h5>
                        <ul className="list-unstyled d-flex flex-column gap-2">
                            <li>
                                <Link to="/contact" className="text-muted">
                                    {getText("Contact", "اتصل بنا")}
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="text-muted">
                                    {getText("Privacy Policy", "سياسة الخصوصية")}
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" className="text-muted">
                                    {getText("Terms of Service", "شروط الخدمة")}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-4">
                        <h5 className="fw-bold mb-3">{getText("Newsletter", "النشرة البريدية")}</h5>
                        <p className="small text-muted">
                            {getText(
                                "Subscribe to get the latest insights.",
                                "اشترك للحصول على أحدث الرؤى."
                            )}
                        </p>
                        <form className="d-flex gap-2">
                            <input
                                type="email"
                                className="form-control bg-body"
                                placeholder="Email address"
                                aria-label="Email"
                            />
                            <button className="btn btn-primary-custom" type="button">
                                {getText("Subscribe", "اشترك")}
                            </button>
                        </form>
                    </div>
                </div>
                <div className="border-top border-secondary mt-5 pt-4 text-center text-muted small">
                    &copy; <span id="year">{currentYear}</span> InnoBridge.{" "}
                    <span>{getText("All rights reserved.", "جميع الحقوق محفوظة.")}</span>
                </div>
            </div>
            <div className="cont-img-footer">
                <img src={getImageUrl('5692bc3b-6ed1-4d67-9d53-8b0176244def.webp', 'imgWeb')} />
            </div>

        </footer>
    );
};

export default Footer;
